import { MobileBaseField } from '../BaseField/models';

export const MobileAccountField = MobileBaseField.extend({
    // used to track if we should show prompt in field view:
    _show_associate_task_prompt: false,
    _show_autofill_prompt: false,

    initialize: function (attrs, options) {
        MobileAccountField.__super__.initialize.apply(this, arguments);
        var this_ = this;

        this.on('change:account', function (_, account) {
            // adding this check here, because `is_primary_location` uses `this.collection` and is not filled up yet on `initialize` scope
            if (!this_.is_primary_location()) {
                return;
            }

            // trigger account:change only if this field is the primary location for the form
            this_.collection.trigger('account:change', account ? account.id : null);
        });
    },

    /**
     * We need to detect a value in the account field differently then otheres. Checking 'value'
     * is insufficient, as new accounts will not have an ID and therefore no value. Instead, we check
     * account.name, since any account (new or old) is required to have a name.
     */
    validation: {
        'account.name': {
            required: function (val, attr, attrs) {
                return this._is_required(val, attr, attrs);
            }
        }
    }
});
